import React from 'react'

import ApplyNowButton from './ApplyNowButton'

const ApplyNow = () => {
  return (
    <section className="bg-gradient-to-r from-indigo-900 to-primary-dark text-white">
      <div className="max-w-4xl mx-auto px-4 py-8 sm:px-6 lg:max-w-screen-2xl lg:px-8 gap-y-4 flex items-center justify-between flex-wrap w-full">
        <p className="text-base md:text-lg lg:text-xl">
          Ready to become a world class tech industry professional{' '}
        </p>

        <ApplyNowButton variant="white" />
      </div>
    </section>
  )
}

export default ApplyNow
